import { PREFIX_IDENTITY_PATH } from "../constant/path";

export const AUTH_API = {
  urlLogin: `${PREFIX_IDENTITY_PATH}/users/login`,
  urlReportSession: `${PREFIX_IDENTITY_PATH}/users/report-session`,
  urlLoginByToken: `${PREFIX_IDENTITY_PATH}/users/login/token`,
  urlLoginByGoogle: `${PREFIX_IDENTITY_PATH}/users/login/google`,
  urlLogout: `${PREFIX_IDENTITY_PATH}/users/logout`,
  urlAuthenticate: `${PREFIX_IDENTITY_PATH}/users/me/info`,
  urlOtpSend: `${PREFIX_IDENTITY_PATH}/otp/create`,
  urlOtpVerify: `${PREFIX_IDENTITY_PATH}/otp/verify`,
  urlCheckExistedUser: `${PREFIX_IDENTITY_PATH}/users/checkExisted`,
  urlGetTrustedDevices: `${PREFIX_IDENTITY_PATH}/users/trusted-devices`,
  urlDeleteSessionsById: (uuid: string) => `${PREFIX_IDENTITY_PATH}/users/sessions/${uuid}`,
  urlDeleteSessionsAll: `${PREFIX_IDENTITY_PATH}/users/sessions`,
  urlDestroyUser: `${PREFIX_IDENTITY_PATH}/users/destroy`,
};
